import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  BUSINESS_ROLES_IDENTIFIER,
  ENTITLEMENTS_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  SHOW_TABLE_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";

const {
  ADDED_BR,
  ADDED_ENTITLEMENTS,
  BUSINESS_ROLES,
  DELEGATOR,
  DELETED_BR,
  DELETED_ENTITLEMENTS,
  ENTITLEMENTS,
  IS_SELF_SELECTED,
  MODIFIED_BR,
  MODIFIED_ENTITLEMENTS,
  OFFICES,
  PREV_ENTITLEMENTS,
  SELECTED_OFFICE,
  SELECTED_USER,
  STEP_FOUR,
  STEP_ONE,
  STEP_THREE,
  STEP_TWO,
  TOTAL_ENTITLEMENTS,
  USER,
  CALL_STATE,
  COMMENT,
  ENTITLEMENTS_BR_SELECTED,
  EXISTING_SAME_DB,
  IS_COMMENT_COMPULSORY,
  SOD_CONFLICTS,
  LIST_FULL,
  START_END_DATE,
  PAGINATED_USERS,
  PAGINATED_BUSINESS_ROLES,
  PAGINATED_ENTITLEMENTS,
} = STATE_IDENTIFIER;

export default {
  [SELECTED_OFFICE]: "",
  [IS_SELF_SELECTED]: false,
  [SELECTED_USER]: [],
  [ADDED_ENTITLEMENTS]: [],
  [ADDED_BR]: [],
  [DELETED_ENTITLEMENTS]: [],
  [DELETED_BR]: [],
  [MODIFIED_ENTITLEMENTS]: [],
  [EXISTING_SAME_DB]: [],
  [MODIFIED_BR]: [],
  [STEP_ONE]: {
    [OFFICES]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
  },
  [STEP_TWO]: {
    [PAGINATED_USERS]: {},
    [USER]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
    },
  },
  [STEP_THREE]: {
    [PREV_ENTITLEMENTS]: {
      [LIST_IDENTIFIER]: {
        [BUSINESS_ROLES_IDENTIFIER]: [],
        [ENTITLEMENTS_IDENTIFIER]: [],
      },
      [LOADER_IDENTIFIER]: false,
      [ENTITLEMENTS_BR_SELECTED]: {
        [LIST_IDENTIFIER]: [],
        [SHOW_TABLE_IDENTIFIER]: false,
      },
    },
    [ENTITLEMENTS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [LIST_FULL]: [],
    },
    [BUSINESS_ROLES]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [TOTAL_ENTITLEMENTS]: {
      [BUSINESS_ROLES_IDENTIFIER]: [],
      [ENTITLEMENTS_IDENTIFIER]: [],
    },
    [START_END_DATE]: [],
    [PAGINATED_ENTITLEMENTS]: {},
    [PAGINATED_BUSINESS_ROLES]: {},
  },
  [STEP_FOUR]: {
    [DELEGATOR]: "",
    [COMMENT]: "",
    [CALL_STATE]: IResponseState.PENDING,
    [IS_COMMENT_COMPULSORY]: true,
  },
  [SOD_CONFLICTS]: null,
  prova: "",
};
